export const ErrorCode = {
    timeout: '网络开小差啦~，请稍后再试'
}